import { isNil } from 'lodash';

export type FormatAmountArgs = {
  amount: number;
  decimalPlaces?: number;
  currency?: string;
  showSign?: boolean;
  notation?: 'standard' | 'scientific' | 'engineering' | 'compact' | undefined;
};
export function formatAmount({
  amount,
  currency,
  decimalPlaces = 2,
  showSign = false,
  notation = 'standard',
}: FormatAmountArgs) {
  if (isNil(amount)) {
    return '';
  }
  // handle -0
  if (Number(amount.toFixed(4)) === 0) {
    amount = 0;
  }

  return amount
    .toLocaleString('en-IN', {
      maximumFractionDigits: amount !== 0 ? decimalPlaces : 0,
      minimumFractionDigits: amount !== 0 ? decimalPlaces : 0,
      currencyDisplay: currency ? 'symbol' : undefined,
      style: currency ? 'currency' : undefined,
      signDisplay: showSign ? 'exceptZero' : undefined,
      currency,
      notation: notation,
      compactDisplay: 'long',
    })
    .replace('T', 'k');
}

export function shortINR(num: number) {
  const map = [
    { value: 1e7, symbol: 'Cr' },
    { value: 1e5, symbol: 'L' },
    { value: 1e3, symbol: 'k' },
  ];

  for (const { value, symbol } of map) {
    if (num >= value) {
      const rounded = Math.round((num / value) * 10) / 10;
      return rounded % 1 === 0
        ? `${rounded}${symbol}`
        : `${rounded.toFixed(1)}${symbol}`;
    }
  }

  return num % 1 === 0
    ? formatAmount({ amount: num, currency: 'INR', decimalPlaces: 0 })
    : formatAmount({ amount: num, currency: 'INR', decimalPlaces: 1 });
}
